import { createPinia, defineStore } from 'pinia'
import piniaPluginPersist from 'pinia-plugin-persist'
import { useCookies } from '@vueuse/integrations/useCookies'
import { router } from '~/router'
import { setToken, removeToken } from '~/utils/auth'
import { getMenuList } from '~/api/menuManage'
import { login, getCurrentUserInfo } from '~/api/userManage'
import { getNoticeInfoUnReadCount } from '~/api/noticeManage'

// 引入持久化插件
const store = createPinia()
store.use(piniaPluginPersist)
const cookie = useCookies()

export const useStore = defineStore('main', {
  state: () => {
    return {
      // 用户信息
      user: {},
      // 菜单信息
      menus: [],
      // 权限
      roleList: [],
      // 侧边宽度
      asideWidth: '260px',
      // 消息数量
      noticeCnt: 0,
      // 全局loading状态
      loading: false,
    }
  },

  getters: {},

  actions: {
    // 咨询师登录
    login({ username, password }) {
      return new Promise((resolve, reject) => {
        const loginForm = {}
        loginForm.username = username
        loginForm.password = password
        login(loginForm).then(response => {
          const token = response.data
          setToken(token)
          resolve(response)
        }).catch(err => reject(err))
      })
    },
    getUserInfo() {
      return new Promise((resolve, reject) => {
        getCurrentUserInfo().then(response => {
          this.user = response.data
          resolve(response)
        }).catch(err => reject(err))
      })
    },
    getNoticeCount() {
      return new Promise((resolve, reject) => {
        getNoticeInfoUnReadCount().then(response => {
          this.noticeCnt = response.data
          resolve(response)
        }).catch(err => reject(err))
      })
    },
    // 退出登录
    logout() {
      // 清除cookie中的token
      removeToken()
      // 清除当前用户状态 vuex
      this.user = {}
      this.menus = []
      this.noticeCnt = 0
      // 清楚cookie中的Tag
      cookie.remove("tabList")
      sessionStorage.clear()
      // 跳转回登录页
      router.push('/login')
    },
    // 记录菜单信息
    getMenu() {
      return new Promise((resolve, reject) => {
        getMenuList().then(response => {
          this.menus = response.data
          resolve(response.data)
        }).catch(err => reject(err))
      })
    },
    handleAsideWidth() {
      this.asideWidth = this.asideWidth == '260px' ? '64px' : '260px'
    },
    changeLoading(bool){
      this.loading = bool
    }
  },
  // 开启数据缓存
  persist: {
    enabled: true,
    strategies: [{
      storage: localStorage, // 表示存储在localStorage
      // key: 'userInfo', // 设置存储的key
      // paths: ['id'], // 指定要长久化的字段
    }]
  }
})
